import React from 'react';

import {Button, InputNumber, ModalPopup} from '@kit';

import {useCharacter} from '../character-context';
import {SPEED_KINDS, SpeedKind} from '../model/character-state';
import {formatFeet} from './format';

import css from './sheet.module.css';

const SPEED_TITLES: Record<SpeedKind, string> = {
	walk: 'Ходьба',
	fly: 'Полёт',
	swim: 'Плавание',
	climb: 'Лазание',
	burrow: 'Копание',
};

type Props = {
	onClose(): void;
};

export const SpeedModal: React.FC<Props> = ({onClose}) => {
	const {state, character, update} = useCharacter();
	const overrides = state.overrides.speeds || {};
	const calculated = character.calculatedSpeeds;

	const setSpeed = (kind: SpeedKind, value: number | undefined) =>
		update((current) => ({
			overrides: {...current.overrides, speeds: {...current.overrides.speeds, [kind]: value}},
		}));

	return (
		<ModalPopup open onClose={onClose} header="Скорости" maxWidth={480}>
			{character.exhaustion > 0 && (
				<p className={css.muted}>
					Утомление снижает расчётные скорости на {formatFeet(5 * character.exhaustion)}.
				</p>
			)}
			<form
				className={css.formRows}
				onSubmit={(event) => {
					event.preventDefault();
					onClose();
				}}
			>
				{SPEED_KINDS.map((kind) => (
					<div key={kind} className={css.formRowControls}>
						<InputNumber
							className={css.formRowInput}
							label={SPEED_TITLES[kind]}
							bottomText={`Расчёт: ${formatFeet(calculated[kind] || 0)}`}
							min={0}
							step={5}
							placeholder={String(calculated[kind] || 0)}
							value={overrides[kind] ?? null}
							onChange={(value) => setSpeed(kind, value ?? undefined)}
						/>
						{overrides[kind] != null && (
							<Button appearance="subtle" onClick={() => setSpeed(kind, undefined)}>
								Сбросить
							</Button>
						)}
					</div>
				))}
				<button type="submit" hidden />
			</form>
			<div className={css.modalButtons}>
				<Button appearance="primary" onClick={onClose}>
					Готово
				</Button>
			</div>
		</ModalPopup>
	);
};
